(() => {
  if (typeof window.customElements.get('product-features') !== 'undefined') { return }

  window.customElements.define('product-features', class ProductFeatures extends HTMLElement { // eslint-disable-line
    constructor () {
      super()

      this.coordinates = this.querySelectorAll('[data-feature-coordinate]')
      this.subheadings = this.querySelectorAll('[data-feature-subheading]')
      this.bodies = this.querySelectorAll('[data-feature-body]')
      this.navItems = this.querySelectorAll('[data-feature-nav-item]')

      if (typeof this.coordinates === 'undefined' || typeof this.subheadings === 'undefined' || typeof this.bodies === 'undefined' || typeof this.navItems === 'undefined') { return }

      this.initProductFeatures()
    }

    initProductFeatures () {
      const displaySubheading = (selectedIndex) => {
        this.subheadings.forEach(subheading => {
          subheading.dataset.featureSubheading === selectedIndex
            ? subheading.classList.add('active-feature')
            : subheading.classList.remove('active-feature')
        })
      }

      const displayBody = (selectedIndex) => {
        this.bodies.forEach(body => {
          body.dataset.featureBody === selectedIndex
            ? body.classList.add('active-feature')
            : body.classList.remove('active-feature')
        })
      }

      const updateCoordinates = (selectedIndex) => {
        this.coordinates.forEach(coordinate => {
          coordinate.dataset.featureCoordinate === selectedIndex
            ? coordinate.classList.add('active-feature')
            : coordinate.classList.remove('active-feature')
        })
      }

      const updateNavItems = (selectedIndex) => {
        this.navItems.forEach(navItem => {
          navItem.dataset.featureNavItem === selectedIndex
            ? navItem.classList.add('active-feature')
            : navItem.classList.remove('active-feature')
        })
      }

      // Coordinate listeners
      this.coordinates.forEach(coord => {
        coord.addEventListener('click', () => {
          const selectedIndex = coord.dataset.featureCoordinate

          displaySubheading(selectedIndex)
          displayBody(selectedIndex)
          updateCoordinates(selectedIndex)
          updateNavItems(selectedIndex)
        })
      })

      // Nav item listeners
      this.navItems.forEach(navItem => {
        navItem.addEventListener('click', () => {
          const selectedIndex = navItem.dataset.featureNavItem

          displaySubheading(selectedIndex)
          displayBody(selectedIndex)
          updateCoordinates(selectedIndex)
          updateNavItems(selectedIndex)
        })
      })
    }
  })
})()